import * as Sentry from '@sentry/react';

import { pickValid } from '@looko-corp/acloset-react-kit/src/utils';

import type { DomainShopResponse } from '@/Swagger';

/**
 * User 를 등록합니다.
 */
export const setUser = (user: Parameters<typeof Sentry.setUser>[0]) => {
  Sentry.setUser(user);
};

/**
 * 샵 정보를 업데이트 합니다.
 */
export const setShop = (shop: Partial<DomainShopResponse>) => {
  Sentry.setContext(
    'shop',
    pickValid({
      shopID: shop.shopID,
      shopName: shop.shopName,
    }),
  );
};
